var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d3c1415164cec0a16b6a68af09532015.svg#Q';
                    var viewUrl = 'sprites.d3c1415164cec0a16b6a68af09532015.svg#view-Q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 21 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };